import { z } from 'zod';
import { Role, UserDTO } from './auth.js';

export const UserListResponse = z.object({
  users: z.array(UserDTO),
});
export type UserListResponse = z.infer<typeof UserListResponse>;

export const UpdateUserInput = z.object({
  role: Role.optional(),
  active: z.boolean().optional(),
  firstName: z.string().trim().min(1).max(80).nullable().optional(),
  lastName: z.string().trim().min(1).max(80).nullable().optional(),
});
export type UpdateUserInput = z.infer<typeof UpdateUserInput>;

// Wer hat sich über einen Einladungslink SELBST eingetragen — und was hat er dabei
// zugestimmt? Der Zeitpunkt gehört zwingend dazu: Bei einer Einwilligung ist er Teil
// des Nachweises, nicht Beiwerk.
export const SignupEntryDTO = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string().nullable(),
  company: z.string().nullable(),
  /** In wessen Netzwerk hat sich die Person eingetragen. */
  hostLabel: z.string(),
  termsAcceptedAt: z.string().nullable(),
  newsletterOptIn: z.boolean(),
  newsletterOptInAt: z.string().nullable(),
  /** true = hat sich danach auch ein eigenes Konto angelegt. */
  hasAccount: z.boolean(),
  createdAt: z.string(),
});
export type SignupEntryDTO = z.infer<typeof SignupEntryDTO>;

export const SignupListResponse = z.object({
  entries: z.array(SignupEntryDTO),
  total: z.number(),
  newsletterCount: z.number(),
});
export type SignupListResponse = z.infer<typeof SignupListResponse>;

